/* eslint-disable boundaries/no-unknown-files */
import type { HubspotWindow } from '@client/feature/customer-chatbots/domain/type/hubspot-window.type.ts'; // @warning must be the first loaded call

const hubspotWindow = window as HubspotWindow;

// must be loaded the fastest way possible, before the loading of the hubspot's script (injected in index.html.twig)
//
// disabling hubspot chatbot autoloading, to authenticate the cockpit user as a visitor user in hubspot before
// so that the chatbot can make responses depending on our authenticated user
// @see https://developers.hubspot.com/docs/api-reference/conversations-visitor-identification-v3/guide
// @see https://developers.hubspot.com/docs/api-reference/conversations-chat-configuration/chat-widget-sdk
hubspotWindow.hsConversationsSettings = {
  loadImmediately: false,
};
